<!-- eslint-disable vue/no-multiple-template-root -->
 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

 <template>
    <header style="padding-left: 30px">
        <h1>
         Step 1: Updating the Class Diagram 
        </h1>

        <p>
            Modify the above class diagram to incorporate the following creational patterns:
            <ul>
                <li>Design a factory class to create objects of the concrete classes - customers and execs.</li>
                <li>Modify the diagram to ensure that only one exec object is created using the singleton pattern.</li>
            </ul>

        </p>
    </header>
    <main>
        <div id="snackbar">Error Message.</div>

        <div class="row">
            <div class="column">
                <div class="codebox" :style="{ display: display[0] }">
                    <img style="max-width: 800px;" src="..\assets\Screen1.png" />
                </div>
                <div class="codebox" :style="{ display: display[1] }">
                    <img style="max-width: 800px;" src="..\assets\Screen2.png" />
            </div>
            <div class="codebox" :style="{ display: display[2] }">
                    <img style="max-width: 800px;" src="..\assets\Screen3.png" />
            </div>
            <div class="codebox" :style="{ display: display[3] }">
                    <img style="max-width: 800px;" src="..\assets\Screen4.png" />
            </div>
            <div class="codebox" :style="{ display: display[4] }">
                    <img style="max-width: 800px;" src="..\assets\Screen5.png" />
            </div>
            <div class="codebox" :style="{ display: display[5] }">
                    <img style="max-width: 800px;" src="..\assets\Screen6.png" />
            </div>
            <div class="codebox" :style="{ display: display[6] }">
                    <img style="max-width: 800px;" src="..\assets\Screen7.png" />
            </div>
            <div class="codebox" :style="{ display: display[7] }">
                    <img style="max-width: 800px;" src="..\assets\Screen8.png" />
            </div>
        </div>
        <div class="column" style="margin-left: 40px">
            <div class="row">
                <div class="codebox" style="max-width: 500px;">
                    <ul>
                        
                        <li :class="{completed: valid[1]}">getPerson(String personType, String name, long phone): Person</li>
                        <li :class="{completed: valid[5]}">getPerson(String personType, String name, String email, long phone): Exec</li>
                        <li :class="{completed: valid[0]}">getPerson(String personType, String name, String email): Person</li>
                        <li :class="{completed: valid[3]}">getPerson(String personType, String name, String email): Customer</li>
                        <li :class="{completed: valid[6]}">getPerson(String personType, String name, String email, long phone): Customer</li>
                        <li :class="{completed: valid[2]}">getPerson(String personType, String name, String email, long phone): Person</li>
                        <li :class="{completed: valid[7]}">getPerson(String personType, Exec name, Exec email, long phone): Person</li>
                        <li :class="{completed: valid[4]}">getPerson(String personType, String name, String email): Exec</li>
                    </ul>
                    

                </div>
            </div>
            <div class="row" style="margin-top:5px">
                    <div class="codebox" style="max-width: 350px;" :style="{ display: display[0] }">
                         Fill in the method from the list above that gets personType, name, email and creates a Person object
                        <br>
                        <br>
                        1. <input v-model="one">
                        <button class="button-9" id="btn1" @click="validate_one()"> Validate </button>
                    </div>
                    <div class="codebox" style="max-width: 350px;" :style="{ display: display[1] }">
                        Fill in the method from the list above that gets personType, name, phone and creates a Person object
                        <br>
                        <br>
                        2. <input v-model="two">
                        <button class="button-9" id="btn2" @click="validate_two()"> Validate </button>
                    </div>
                    <div class="codebox" style="max-width: 350px;" :style="{ display: display[2] }">
                        Fill in the method from the list above that gets personType, name, phone, email and creates a Person object
                        <br>
                        <br>
                        3. <input v-model="three">
                        <button class="button-9" id="btn3" @click="validate_three()"> Validate </button>
                    </div>
                    <div class="codebox" style="max-width: 350px;" :style="{ display: display[3] }">
                        <button class="button-9" @click="$router.push('/screen-two')">Next</button>
                    </div>
            </div>
            </div>
        </div>
        
    </main>
</template>

<script>

export default {
    methods: {
        correct1() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Correct";
      x.style.backgroundColor = "green";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
        validate_one() {
            if (this.one == "getPerson(String personType, String name, String email): Person") {
                this.display[0] = "none";
                this.display[1] = "block";
                this.valid[0] = true;
                this.correct1();
            }

            else {
                var x = document.getElementById("snackbar");
                x.innerHTML = "Incorrect. Try again";
                x.style.backgroundColor = "red";
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
            }

        },
        validate_two() {
            if (this.two == "getPerson(String personType, String name, long phone): Person") {
                this.display[1] = "none";
                this.display[2] = "block";
                this.valid[1] = true;
                this.correct1();
            }
            else {
                var x = document.getElementById("snackbar");
                x.innerHTML = "Incorrect. Try again";
                x.style.backgroundColor = "red";
                x.className = "show";
                
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
            }

        },
        validate_three() {
            if (this.three == "getPerson(String personType, String name, String email, long phone): Person") {
                this.display[2] = "none";
                this.display[3] = "block";
                this.valid[2] = true;
                this.correct = true;
                this.correct1();
            }
            else {
                var x = document.getElementById("snackbar");
                x.innerHTML = "Incorrect. Try again";
                x.style.backgroundColor = "red";
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
            }
        },
    },
    data() {
        return {
            id: 'container',
            class: 'wrapper',
            button_text: "Incorrect. Try again.",
            button_text_right: "Next",
            correct: false,
            valid: [false, false, false],
            display: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none"]
        }
    }
}


</script>

<style scoped>
* {
    box-sizing: border-box;
    background-color: #F9FAFE;
}


h1,
h2,
p {
    font-family: sans-serif;
    color: rgb(0, 3, 40);
}

.row {
    display: flex;
}

.column {
    flex: 50%;
}

.completed {
    color: cadetblue;
    text-decoration: line-through;
}

.codebox li{
    margin-bottom: 10px;
    font-family: monospace;
}

mark1 {
    background-color: rgb(176, 230, 183);
    box-shadow: 1px 6px 15px 2px rgb(160, 222, 159);
    color: black;
    border-radius: 10px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
    padding-bottom: 6px;
}

mark0 {
    box-shadow: 1px 6px 15px 2px rgb(249, 255, 191);
    background-color: rgb(231, 238, 162);
    color: black;
    border-radius: 10px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
    padding-bottom: 6px;
}

#comment {
    margin-left: 15px;
    font-style: italic;
    color: gray;
    font-size: small;
}


.codebox {
    height: 100%;
    width: 100%;
    padding: 25px;
    border-radius: 10px;
    margin: 15px;
    background-color: #F9FAFE;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
}

input {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
    background-color: white;
    color: black;
}

/* CSS */
.button-9 {
    appearance: button;
    backface-visibility: hidden;
    background-color: #405cf5;
    border-radius: 6px;
    border-width: 0;
    box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    font-family: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif;
    font-size: 100%;
    height: 44px;
    line-height: 1.15;
    margin: 12px 0 0;
    outline: none;
    overflow: hidden;
    padding: 0 25px;
    position: relative;
    text-align: center;
    text-transform: none;
    transform: translateZ(0);
    transition: all .2s, box-shadow .08s ease-in;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    width: 200px;
}

.button-9:disabled {
    cursor: default;
}

.button-9:focus {
    box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .2) 0 6px 15px 0, rgba(0, 0, 0, .1) 0 2px 2px 0, rgba(50, 151, 211, .3) 0 0 0 4px;
}

#snackbar {
    visibility: hidden;
    min-width: 250px;
    margin-left: -125px;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    padding: 16px;
    position: fixed;
    z-index: 1;
    left: 50%;
    bottom: 30px;
    font-size: 17px;
}

#snackbar.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
    from {
        bottom: 0;
        opacity: 0;
    }

    to {
        bottom: 30px;
        opacity: 1;
    }
}

@keyframes fadein {
    from {
        bottom: 0;
        opacity: 0;
    }

    to {
        bottom: 30px;
        opacity: 1;
    }
}

@-webkit-keyframes fadeout {
    from {
        bottom: 30px;
        opacity: 1;
    }

    to {
        bottom: 0;
        opacity: 0;
    }
}

@keyframes fadeout {
    from {
        bottom: 30px;
        opacity: 1;
    }

    to {
        bottom: 0;
        opacity: 0;
    }
}
</style>